import { VariableDTO } from 'jobs/dtos/variables'
import { action, makeObservable, observable } from 'mobx'
import { DEFAULT, match } from 'utils/pattern-match-util'
import {
  BooleanVariableViewModel,
  ListVariableViewModel,
  NumberVariableViewModel,
  StringVariableViewModel,
  UnknownVariableViewModel,
  VariableViewModel,
} from './VariableViewModelBase'

/**
 * Variables list.
 */
export default class VariableListViewModel {
  /**
   * Variable view model.
   */
  @observable variables: VariableViewModel[] = []

  constructor() {
    makeObservable(this)
  }

  /**
   * Reconciles the variables view models with the DTOs.
   *
   * @param dtos
   */
  @action.bound
  reconcile(dtos: VariableDTO[]) {
    const newVariables: VariableViewModel[] = []

    for (const [, dto] of dtos.entries()) {
      const viewModel = this.getVariableViewModel(dto.valueType.type)

      viewModel.hydrateDTO(dto as any)
      newVariables.push(viewModel)
    }

    this.variables = newVariables
  }

  getVariableViewModel(type: VariableDTO['valueType']['type']) {
    return match<VariableDTO['valueType']['type'], VariableViewModel>(type, {
      Boolean: () => new BooleanVariableViewModel(),
      String: () => new StringVariableViewModel(),
      Number: () => new NumberVariableViewModel(),
      List: () => new ListVariableViewModel(),
      [DEFAULT]: () => new UnknownVariableViewModel(),
    })
  }
}
